/*--------------------------------------------------------------
# Custom scripts for Tombstone block
--------------------------------------------------------------*/

const tombstoneSliders = document.querySelectorAll('.tombstone .tombstone-swiper');

tombstoneSliders.forEach((slider, index) => {
	const block = slider.closest('.tombstone');
	const nextArrow = block?.querySelector('.tombs-swiper-next');
	const prevArrow = block?.querySelector('.tombs-swiper-prev');

	if (!nextArrow || !prevArrow) {
		return;
	}

	slider.classList.add(`tombs-swiper-${index}`);
	nextArrow.classList.add(`tombs-swiper-next-${index}`);
	prevArrow.classList.add(`tombs-swiper-prev-${index}`);

	// eslint-disable-next-line no-unused-vars
	const initTombstoneSlider = new Swiper(`.tombs-swiper-${index}`, {
		simulateTouch: true,
		grabCursor: true,
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 24,
		loop: false,
		watchOverflow: true,
		navigation: {
			nextEl: `.tombs-swiper-next-${index}`,
			prevEl: `.tombs-swiper-prev-${index}`,
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
			},
			992: {
				slidesPerView: 3,
			},
			1200: {
				slidesPerView: 4,
			},
		},
	});
});
